// extracted by mini-css-extract-plugin
module.exports = {"surveyContent":"styles_surveyContent___dX2U"};